export const iconFontAwesomeSecurityPersonBurst = (
	<i className="fa-solid fa-person-burst"></i>
);
